import React from 'react'
import { Button, ErrorText } from '@welbe/web-design-system'

import { InputRange } from './components/InputRange/InputRange'
import { InputRadio } from './components/InputRadio/InputRadio'
import { Form } from './components/Form/Form'
import { Container, ContainerButton } from './Builder.styles'
import { Alert } from 'App/components/Alert/Alert'

interface BuilderProps {
	data: any
	questionAnswerModels?: any
	onFinish?: (e: any) => void
	resetFormError: () => any
	formError?: boolean
	isLoadingForm?: boolean
	onChange?: any
}

const getWithQuestionIsVisible = (dependences: any, dataQuestions: any) => {
	if (dependences.length) {
		const isValidate = dependences.every((dependence: any) => {
			const targetDependence = dataQuestions.find(
				(question: any) => question.id === dependence.questionDependId,
			)

			if (
				targetDependence?.campaignQuestionAnswer?.questionAnswerId ===
				dependence.questionAnswerId
			) {
				return true
			} else {
				return false
			}
		})

		return isValidate
	} else {
		return true
	}
}

const NullComponent = (): JSX.Element => <></>

const getInputType = (type: 'radio' | 'range') => {
	if (type === 'radio') {
		return InputRadio
	}
	if (type === 'range') {
		return InputRange
	}
	return NullComponent
}

export const Builder = ({
	data,
	questionAnswerModels,
	onFinish,
	resetFormError,
	formError,
	isLoadingForm,
	onChange,
}: BuilderProps): JSX.Element => {
	const isMobile = window.innerWidth <= 768
	const handleFinish = (e: any) => {
		onFinish && onFinish(e)
	}

	return (
		<Form onSubmit={handleFinish}>
			<Container>
				{data.questions.map((question: any) => {
					const modelQuestionProps = questionAnswerModels.find(
						(questionAnswer: any) =>
							questionAnswer.id === question.questionAnswerModelId,
					)

					const isVisible = getWithQuestionIsVisible(
						question.questionDependencies,
						data.questions,
					)

					const InputComponent = getInputType(modelQuestionProps.type)

					return (
						<InputComponent
							key={question.campaignQuestionAnswer.id}
							id={question.campaignQuestionAnswer.id}
							text={question.description}
							options={modelQuestionProps?.questionAnswers}
							onChange={onChange}
							isVisible={isVisible}
							questionAnswerId={
								question.campaignQuestionAnswer.questionAnswerId
							}
						/>
					)
				})}

				<ContainerButton>
					<Button loading={isLoadingForm} width="260px" type="submit">
						Continuar
					</Button>
					{formError && (
						<div>
							{isMobile ? (
								<Alert onClearError={() => resetFormError()}>
									Rellene todos los campos correctamente
								</Alert>
							) : (
								<ErrorText>Rellene todos los campos correctamente</ErrorText>
							)}
						</div>
					)}
				</ContainerButton>
			</Container>
		</Form>
	)
}
